module.exports = __webpack_public_path__ + "static/media/AlcoholActive.a57765e3.svg";